import { Component } from "react";
import Box from '@mui/material/Box';
import RecoverPasswordFourthInner from "./RecoverPasswordFourthInner";
import FormHeader from "../../../../components/FormHeader";

type Props = {
};

type State = {
}

export default class RecoverPasswordFourth extends Component<Props, State> {
  redirect: string='/web/login'

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <Box>
        <FormHeader title="Nueva contraseña"></FormHeader>
        <RecoverPasswordFourthInner redirect={this.redirect} acceptButtonText='Ingresar'></RecoverPasswordFourthInner>
      </Box>
    );
  }
}